import ClearIcon from '@mui/icons-material/Clear';
import { Alert, AlertProps, Box, Card, CardContent, Divider, IconButton, List, ListItem, ListItemText } from '@mui/material';
import { Criterion } from '../../shared/types';
import { CriterionEntry } from './CriterionEntry';

type Props = {
    label: string;
    severity?: AlertProps['severity'];
    edit?: boolean;
    onChange?: (criterions: Criterion[]) => void;
    criterion?: Criterion[];
};

export const CriterionList = ({ label, severity = 'info', edit, criterion = [], onChange }: Props) => {
    const handleCriterionAdd = (newCriterion: Criterion) => {
        if (onChange) {
            onChange([...criterion, newCriterion]);
        }
    };

    const handleCriterionDelete = (deleteIndex: number) => {
        const newCriterion = criterion.filter((_, index) => index !== deleteIndex);

        if (onChange) {
            onChange(newCriterion);
        }
    };

    return (
        <Card variant="outlined" sx={{ backgroundColor: 'transparent' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Alert variant="filled" severity={severity} icon={false} sx={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}>
                    {label}
                </Alert>
                {edit && (
                    <>
                        <CardContent sx={{ height: 100 }}>
                            <CriterionEntry disableList={criterion} onAdd={handleCriterionAdd} label="Add Criteria" />
                        </CardContent>
                        <Divider />
                    </>
                )}
                <List disablePadding={true}>
                    {criterion.map(({ threshold, criteria }, index) => {
                        const { text, unit } = criteria;
                        const description = `${text} ${threshold} ${unit}`;

                        return (
                            <ListItem
                                key={index}
                                secondaryAction={
                                    edit && (
                                        <IconButton edge="end" aria-label="delete" onClick={() => handleCriterionDelete(index)}>
                                            <ClearIcon />
                                        </IconButton>
                                    )
                                }
                                divider={index + 1 < criterion.length}>
                                <ListItemText primary={description} />
                            </ListItem>
                        );
                    })}
                </List>
            </Box>
        </Card>
    );
};
